import { createContext } from "react"
import type { ErrorMessage } from "src/types/ErrorMessage"

export interface ErrorBannerContextProps {
	showError: (error: ErrorMessage | undefined) => void
}

const initialErrorBannerContext = {
	showError: () => {
		throw new Error("You are trying to use ErrorBanner outside ErrorBannerProvider")
	},
}

export const ErrorBannerContext = createContext<ErrorBannerContextProps>(initialErrorBannerContext)
